import classNames from "classnames"
import React, { useEffect, useState } from "react"
import { shallowEqual, useSelector } from "react-redux"
import BraceletProductItem from "./BraceletProductItem"
import "./BraceletProductList.scss"

function BraceletsProductList() {
  const products = useSelector((state) => state.stacker.products, shallowEqual)
  const lastApplied = useSelector((state) => state.stacker.lastApplied)

  //const [list, setList] = useState(null)

  // useEffect(() => {
  //   setList(
  //     products.map((product, index) => {
  //       return (
  //         <BraceletProductItem
  //           key={`${product.code} - ${index} - ${lastApplied}`}
  //           product={product}
  //           index={index}
  //         />
  //       )
  //     })
  //   )
  // }, [lastApplied, products])

  const productAmt = products.length
  const classes = classNames(
    "product_list-body-list product_list-bracelets grid",
    {
      "column-1-override": productAmt === 1,
    }
  )
  return (
    <div className={classes}>
      {products.map((product, index) => {
        return (
          <BraceletProductItem
            key={`${product.code} - ${index} - ${lastApplied}`}
            product={product}
            index={index}
          />
        )
      })}
    </div>
  )
}

export default BraceletsProductList
